import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { bffWebApi, TagTypes } from '~/api';
import type { AppState } from '~/reducers';

const useSyncFilterOptions = () => {
  const dispatch = useDispatch();
  const { assetCreatedDate, assetDeletedDate } = useSelector(
    (state: AppState) => state.assetsCounts
  );

  const lastSeenDatesRef = useRef({ created: assetCreatedDate, deleted: assetDeletedDate });

  useEffect(() => {
    const prev = lastSeenDatesRef.current;
    const createdChanged = assetCreatedDate !== prev.created;
    const deletedChanged = assetDeletedDate !== prev.deleted;
    lastSeenDatesRef.current = { created: assetCreatedDate, deleted: assetDeletedDate };

    if (createdChanged || deletedChanged) {
      const timer = setTimeout(() => {
        dispatch(bffWebApi.util.invalidateTags([TagTypes.FilterOptions]));
      }, 300);
      return () => clearTimeout(timer);
    }
  }, [assetDeletedDate, assetCreatedDate, dispatch]);
};

export default useSyncFilterOptions;
